import type { ManifestSchemaItem, ManifestSchemaItems } from "@otto-ec/ottoapi-cli";

export function getChildren(item: ManifestSchemaItem): ManifestSchemaItems {
  return item.children?.items?.children ?? item.children ?? {};
}
